import React from 'react';
import { Box } from 'grommet';
import styled from 'styled-components';

const Track = styled.div`position: relative; height: 10px;`;
const Fill = styled(Box)`height: 100%;`;
const Tick = styled(Box)`position: absolute; top: -3px; bottom: -3px; width: 2px;`;

// How long it has been, with a tick at what's usual
const GapTrack = ({ value, usual, max }) => (
    <Track>
        <Box fill round="3px" background="chart-muted">
            <Fill round="3px" background="barchart-primary" style={{ width: `${100 * value / max}%` }} />
        </Box>
        <Tick background="text" style={{ left: `${100 * usual / max}%` }} />
    </Track>
);

export default GapTrack;
